<div class="d-flex justify-content-center">
    <div class="d-flex flex-column p-5 mt-4 help-page">
        @if (hasViewPermission) {
            <div class="help-panel-content">
                <h3>PropertyPoint Support <b>Help Desk</b></h3>
                <ul>
                    <li>Click <a href="https://softwaresupport.ryan.com/" target="_blank">HERE</a>
                        to open the PropertyPoint Help Desk where you can find a growing product<br>
                        knowledge base with detailed training articles and additional product Support.
                    </li>
                </ul>
            </div>
            @if (hasRyanInstanceSelected) {
                <div class="help-panel-content">
                    <h3>Property Tax <b>Knowledge Hub</b></h3>
                    <ul>
                        <li>Click
                            <a href="https://ryan8318.zendesk.com" target="_blank">HERE</a> to open the Ryan Property Tax
                            Knowledge Hub.<br>
                            <p>Providing Ryan team members with quick access to property tax resources - including<br>
                                articles containing standardized processes, policies, best practices, jurisdiction<br>
                                information, property tax news, and essential links.</p>
                        </li>
                    </ul>
                </div>
            }
        } @else {
            <div class="row">
                <div class="help-panel-content mt-0">
                    <p>Reach out to your Ryan contact or Account Handler if you need assistance with client support or
                        navigation issues.</p>
                    <p>For system issues, click here to open the
                        <a href="https://softwaresupport.ryan.com/" target="_blank">PropertyPoint Help Desk</a></p>
                    <p>For the best browsing experience we recommend using Google Chrome.</p>
                </div>
            </div>
        }
    </div>
</div>
